import type { SVGProps } from "react";

export const Role = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.0059 8.01781L7.51182 4.51189L6.33331 3.33337L4.0059 5.66079L2.51182 4.16671L1.33331 5.34522L4.0059 8.01781ZM4.0059 16.3511L7.51182 12.8452L6.33331 11.6667L4.0059 13.9941L2.51182 12.5L1.33331 13.6786L4.0059 16.3511ZM8.83331 5.00004H18.8333V6.66671H8.83331V5.00004ZM18.8333 13.3334H8.83331V15H18.8333V13.3334Z"
    />
  </svg>
);
